export const getCalcedPercents = (currentStep: number) => {
	const maxSteps = 16.5
	const percent = Math.floor((currentStep / maxSteps) * 100)
	return percent >= 100 ? 100 : percent
}
